<template>
  <el-container class="index-con">
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>
    <div class="index-page"></div>
    <div style="padding-top: 40px;">
      <div class="main-con">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">海量数据</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path:'/index/live' }">直播</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path:'/index/classroomDetails?id='+id+'&type=1&path=2' }">直播详情</el-breadcrumb-item>
            <el-breadcrumb-item>{{itemName}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- 播放 -->
        <div class="broadcast">
          <!-- <p class="broadcast-title">{{itemName}}</p> -->
          <div class="broadcast-zx">
            <img src="../../assets/img/icon21.png">
            <span>课程直播</span>
          </div>
          
          <div v-if="status == 1">
            <video  id="player-container-id" style="width: 100%;" preload="auto" playsinline webkit-playsinline>
            </video>
          </div>
         

          <div v-else style="width: 100%; height: 600px; background: #111; display: flex;align-items: center;justify-content: center; ">
            <p style="font-size: 20px; letter-spacing: 2px; color: #fff;">未开播</p>
          </div>
          
        </div>
      </div>
    </div>

    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
export default {
  name: 'playback',
  // 注册组件
  components: {
    navcon,
    footers,

  },
  data() {
    return {
      id:'',
      url:'',
      status:1,
      player:null
    }
  },
  created(){
    this.id = this.$route.query.id;
    this.status = this.$route.query.status; 
  },
  mounted(){
    this.url = this.$route.query.url;
    
    // this.url = 'http://pull.vastdata.com.cn/vast/c86cdbb7a6.m3u8?txSecret=4a33d0dc5cafd5c2220e3fc2a6d856c1&txTime=67662EB2';
    var player = new TCPlayer('player-container-id', {
      sources: [{
        src: this.url, // 播放地址
      }],
      licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1305111013_1/v_cube.license', // license 地址，参考准备工作部分，在视立方控制台申请 license 后可获得 licenseUrl
      autoplay: true, // 是否自动播放
      fakeFullscreen:false
    });

    this.player = player;

    // 监听播放事件
    player.on('play', onPlayerPlay);

    // 监听暂停事件
    player.on('pause', onPlayerPause);

    // 监听结束事件
    player.on('error',(error)=>{
      this.status = error.data.code;
      console.log('播放器结束');
    })

    
    // this.player.src(this.url); // url 播放地址
   
  },
  beforeDestroy(){
    console.log("资源清理",this.player)
    if(this.player){
      this.player.dispose();
    }
  }
 
}
function onPlayerPlay(event) {
    console.log(event)
    console.log('播放器播放');
}

function onPlayerPause(event) {
    console.log(event)
    console.log('播放器暂停');
}

</script>
<style scoped>
  @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }

  父级div{
    position: relative;
  }
  子级div{
    position: fixed;
  }

  .main-con {
    margin: auto;
    padding-bottom: 40px;

   
    
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }

  .index-main{
    margin-left: 20px !important;
  }
  .index-header,
  .index-main,
  .index-footer {
    padding: 0px;
    height: auto;
    margin: 0; 
  }

  .broadcast{
    margin-top: 40px;
  }
  .broadcast-title{
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 18px;
  }
  .broadcast-zx{
    margin: 14px 0 24px;
    display: flex;
    align-items: center;
  }
  .broadcast-zx img{
    width: 10px;
    margin-right: 6px;
  }
  .broadcast-zx span{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #B6B7BA;
    line-height: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/tcplayer.vue